var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wraper",style:(_vm.wraperStyleText),attrs:{"data-flex":"dir:top main:center cross:center"}},[_c('img',{staticClass:"img",attrs:{"src":"static/img/no-data.png","alt":""}}),_vm._v(" "),_c('span',{style:(_vm.tipsStyleText),attrs:{"data-flex-box":"0"}},[_vm._v(_vm._s(_vm.tips))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4293b1f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/no_data.vue
// module id = null
// module chunks = 